import api from './api';

const archivedContractService = {
  // Get all archived contracts
  getAllArchivedContracts: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.archiveReason) queryParams.append('archiveReason', params.archiveReason);
      if (params.contractType) queryParams.append('contractType', params.contractType);
      if (params.partyId) queryParams.append('partyId', params.partyId);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.canBeDeleted) queryParams.append('canBeDeleted', params.canBeDeleted);

      const queryString = queryParams.toString();
      const url = `/archived-contract${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching archived contracts:', error);
      throw error;
    }
  },

  // Get archived contract by ID
  getArchivedContractById: async (id) => {
    try {
      const response = await api.get(`/archived-contract/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching archived contract:', error);
      throw error;
    }
  },

  // Get next archive number
  getNextArchiveNumber: async () => {
    try {
      const response = await api.get('/archived-contract/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next archive number:', error);
      throw error;
    }
  },

  // Archive a signed contract
  archiveContract: async (signedContractId, archiveData) => {
    try {
      const response = await api.post(`/archived-contract/archive/${signedContractId}`, archiveData);
      return response.data;
    } catch (error) {
      console.error('Error archiving contract:', error);
      throw error;
    }
  },

  // Update archived contract
  updateArchivedContract: async (id, contractData) => {
    try {
      const response = await api.put(`/archived-contract/${id}`, contractData);
      return response.data;
    } catch (error) {
      console.error('Error updating archived contract:', error);
      throw error;
    }
  },

  // Delete archived contract
  deleteArchivedContract: async (id) => {
    try {
      const response = await api.delete(`/archived-contract/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting archived contract:', error);
      throw error;
    }
  },

  // Get archived contract statistics
  getArchivedContractStats: async () => {
    try {
      const response = await api.get('/archived-contract/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching archived contract statistics:', error);
      throw error;
    }
  }
};

export default archivedContractService;

